import { ChangeDetectionStrategy, Component, Input, ElementRef, AfterViewInit, Renderer2 } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FilterControlKeys, FilterType } from '../../shared.models';

@Component({
    selector: 'liebherr-filter-control',
    templateUrl: './filter-control.component.html',
    styleUrls: ['./filter-control.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FilterControlComponent implements AfterViewInit {
    @Input() control?: UntypedFormGroup;
    @Input() width = 'calc(50% - 1rem)';
    CONTROL_KEYS = FilterControlKeys;
    FILTER_TYPE = FilterType;

    constructor(private el: ElementRef, private renderer: Renderer2) {}
    ngAfterViewInit() {
        this.renderer.setStyle(this.el.nativeElement, 'width', this.width);
    }
}
